import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {CityInfo, MarketingStatisticsBase, MarketingTotals} from "../dto/GeoIp/city-info";
import {DatePipe} from "@angular/common";
import {MarketingStatsFilter} from "../dto/marketingStatsFilter";

@Injectable({
  providedIn: 'root'
})
export class MarketingStatisticsService {

  readonly apiPath = 'marketing-statistics/';
  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
  ) { }

  getOrders(
    startDate: Date,
    endDate: Date,
    grouping: number,
    interval: number,
    filters: MarketingStatsFilter,
  ): Observable<MarketingStatisticsBase[]> {

    var filterModel = {
      startDate: this.datePipe.transform(startDate, 'yyyy-MM-dd'),
      endDate: this.datePipe.transform(endDate, 'yyyy-MM-dd'),
      companyIds: filters.companyIds,
      productIds: filters.productIds,
      countryIsoCodes: filters.countryIsoCodes,
      platform: filters.platform,
      grouping: grouping,
      interval: interval,
    }

    return this.http.post(this.apiPath + "orders", filterModel) as Observable<MarketingStatisticsBase[]>;
  }

  getTotals(
      startDate: Date,
      endDate: Date,
      grouping: number,
      interval: number,
      filters: MarketingStatsFilter,
  ): Observable<MarketingTotals> {

    var filterModel = {
      startDate: this.datePipe.transform(startDate, 'yyyy-MM-dd'),
      endDate: this.datePipe.transform(endDate, 'yyyy-MM-dd'),
      companyIds: filters.companyIds,
      productIds: filters.productIds,
      countryIsoCodes: filters.countryIsoCodes,
      platform: filters.platform,
      grouping: grouping,
      interval: interval,
    }

    return this.http.post(this.apiPath + "totals", filterModel) as Observable<MarketingTotals>;
  }

  getLoads(
    startDate: Date,
    endDate: Date,
    grouping: number,
    interval: number,
    filters: MarketingStatsFilter,
  ): Observable<MarketingStatisticsBase[]> {

    var filterModel = {
      startDate: this.datePipe.transform(startDate, 'yyyy-MM-dd'),
      endDate: this.datePipe.transform(endDate, 'yyyy-MM-dd'),
      companyIds: filters.companyIds,
      productIds: filters.productIds,
      countryIsoCodes: filters.countryIsoCodes,
      platform: filters.platform,
      grouping: grouping,
      interval: interval,
    }

    return this.http.post(this.apiPath + "loads", filterModel) as Observable<MarketingStatisticsBase[]>;
  }
}
